import {NgModule} from '@angular/core';
import {CommonSectionsModule} from '../../views/common/common-sections.module';
import {BorrowerCampaignComponent} from './borrower-campaign.component';
import {CommonBorrowSectionModule} from '../common-borrow-sections/common-borrow-section.module';
import {CampaignEnquireFooterModule} from '../../common/campign-enquire-footer/campaign-enquire.module';
import {MatButtonModule} from '@angular/material';

@NgModule({
    declarations: [BorrowerCampaignComponent],
    imports: [CommonSectionsModule, CommonBorrowSectionModule, CampaignEnquireFooterModule, MatButtonModule]
})
export class BorrowerCampaignModule {
}